import { TenantUserFields } from "../TenantUserFields";
import { v4 as uuid } from "uuid";
import {Model} from "../base/Model";
import {Collection} from "../base/Collection";
import { HumanModel } from "./Human";
import { AddressModel } from "./Address";
import { ContactModel } from "./Contact";

export class FieldTypesModel extends Model  {
    fieldkey: string;
    fieldval: string;
    asgroup: boolean;
    locked: boolean;
    constructor(data = null) {
        super();
        
        if(data) {
            this.createModel(data);
        }
        
  //      
    }
}